import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { OOVenueService } from 'src/app/core/services/venue-service';
import { EmployeeAutomaticMessageItem } from 'src/app/shared/models/EmployeeAutomaticMessage.item';
import { Job } from 'src/app/shared/models/focusDataModels/Job';

@Component({
	selector: 'app-automatic-employee-message-list',
	templateUrl: './automatic-employee-message-list.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class AutomaticEmployeeMessageListComponent implements OnInit, OnDestroy {
	automaticEmployeeMessageList: EmployeeAutomaticMessageItem[];
	subscriptionList: Subscription = new Subscription();

	jobList: Job[];

	constructor(public app: AppService, public venueService: OOVenueService, private focuslink: FocuslinkService, private router: Router) {}

	ngOnDestroy(): void {
		this.subscriptionList.unsubscribe();
	}

	ngOnInit(): void {
		this.app.loading(true);
		this.subscriptionList.add(
			this.venueService.automaticEmployeeMessageList.subscribe((data) => {
				this.automaticEmployeeMessageList = [...data];
				if (this.automaticEmployeeMessageList?.length > 0 && this.jobList?.length > 0) {
					this.jobNamesToJobIds();
				}
			})
		);

		this.subscriptionList.add(
			this.venueService.jobList.subscribe((data) => {
				this.jobList = [
					new Job({
						id: 999,
						name: 'All Jobs',
					}),
				];
				this.jobList = this.jobList.concat([...data]);
				this.app.loading(false);
				if (this.automaticEmployeeMessageList?.length > 0 && this.jobList?.length > 0) {
					this.jobNamesToJobIds();
				}
			})
		);

		this.getAutomaticEmployeeMessageList(this.venueService.subscriptionVenue.value.key);
		this.getJobs(this.venueService.subscriptionVenue.value.key);
	}

	async getAutomaticEmployeeMessageList(venueKey): Promise<EmployeeAutomaticMessageItem[]> {
		const resp = await this.focuslink.employeeAutoMessageGetAll(venueKey);
		this.venueService.automaticEmployeeMessageList.next(resp.map((i) => new EmployeeAutomaticMessageItem(i)));
		return this.venueService.automaticEmployeeMessageList.value;
	}

	async getJobs(venueKey): Promise<Job[]> {
		const resp = await this.focuslink.configsJobs(venueKey);

		this.venueService.jobList.next(resp.map((i) => new Job(i)));
		return this.venueService.jobList.value;
	}

	jobNamesToJobIds() {
		this.automaticEmployeeMessageList.forEach((msg) => {
			msg.jobName = this.jobList.find((i) => i.id === msg.jobId)?.name;
		});
	}

	selectMessage(rec: EmployeeAutomaticMessageItem) {
		this.router.navigate([`/cc/communication/automessages/${rec.sk}`]);
	}
}
